<div class="loader-container">
  <mat-spinner color="primary" />
</div>
